import { TextField, InputAdornment, Box, useMediaQuery } from '@mui/material';
import { IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { setAllSearchTexts } from 'src/store/my_pages/app';
import { AppState, dispatch } from 'src/store/Store';

const HoverExpanSearchBtn = ({ searchKey, placeholder, disableCollapse = false }: { searchKey?: string; placeholder?: string; disableCollapse?: boolean }) => {
  const FORCE_DISABLE_COLLAPSE_FEATURE = true; // test
  disableCollapse = FORCE_DISABLE_COLLAPSE_FEATURE;  // test

  const { allSearchTexts } = useSelector((state: AppState) => state.appGeneralReducer);
  const [isHover, setIsHover] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width: 600px)');
  const isXSmallScreen = useMediaQuery('(max-width: 400px)');
  const [initialLoad, setInitialLoad] = useState(true);
  const EXPANDED_PX = isXSmallScreen ? '200px' : '220px';
  const COLLAPSED_PX = '45px';

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setAllSearchTexts({ key: searchKey, value: event.target.value }));
  };

  useEffect(() => {
    dispatch(setAllSearchTexts({ key: searchKey, value: '' }));
  }, [searchKey]);

  // Calculate width based on conditions
  const getWidth = () => {
    if (!disableCollapse) {
      if (isSmallScreen) return EXPANDED_PX;
      if (disableCollapse) return EXPANDED_PX;
      if (allSearchTexts?.[searchKey]) return EXPANDED_PX;
      if (isHover) return EXPANDED_PX;
      return COLLAPSED_PX;
    } else {
      return EXPANDED_PX;
    }
  };

  // After initial render, set initialLoad to false to allow normal behavior
  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoad(false);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box sx={{ width: EXPANDED_PX, position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
      <TextField
        id={'outlined-search' + searchKey}
        key={'HoverExpanSearchBtn' + searchKey}
        placeholder={placeholder || 'Search...'}
        size="small"
        type="search"
        variant="outlined"
        value={allSearchTexts?.[searchKey] || ''}
        onChange={handleChange}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => {
          setTimeout(() => {
            setIsHover(false);
          }, 2000);
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '3rem',
            width: initialLoad ? (disableCollapse ? EXPANDED_PX : isSmallScreen ? EXPANDED_PX : COLLAPSED_PX) : getWidth(),
            height: COLLAPSED_PX,
            transition: 'width 0.3s ease',
            '& .MuiOutlinedInput-notchedOutline': {
              borderRadius: '3rem',
            },
            '& .MuiInputAdornment-root': {
              position: 'relative',
              right: disableCollapse ? '0px' : allSearchTexts?.[searchKey] || isHover || isSmallScreen ? '0px' : '20px',
              transition: 'all 0.3s ease',
            },
          },
        }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconSearch size={'16'} />
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default HoverExpanSearchBtn;
